import React, { useState } from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";
import Icon from "../../../components/Icon";

// FAQ data pour les mémos et relances prospects
const faqItems = [
  {
    id: 1,
    title: "Mémos personnalisés pour chaque prospect",
    content: "Créez et gérez des mémos détaillés pour chaque prospect afin de personnaliser votre approche et sauvegarder un historique de vos interactions."
  },
  {
    id: 2,
    title: "Système de relances automatisées",
    content: "Programmez des relances automatiques pour ne jamais perdre le contact avec vos prospects et maximiser votre taux de transformation.",
    details: [
      "Relances par email automatiques",
      "Planification personnalisée", 
      "Suivi des interactions prospects"
    ]
  }
];

const ExportEmargement = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          {/* Côté gauche - Galerie d'images */}
          <div className={styles.leftContent}>
            <div className={styles.gallery}>
              {/* Image principale au centre */}
              <div className={styles.mainImage}>
                <div className={styles.imageBackground}>
                  <ScrollParallax animateIn="fadeInUp" offset={200}>
                    <img
                      src="/images/content/export-illustration.svg"
                      alt="Interface d'export des feuilles"
                      className={styles.centralImage}
                    />
                  </ScrollParallax>
                </div>
              </div>
              
              {/* Éléments flottants autour */}
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInLeft" 
                offset={300}
                style={{
                  position: 'absolute',
                  top: '10%',
                  left: '5%',
                  zIndex: 3
                }}
              >
                <img
                  src="/images/content/export-email.svg"
                  alt="Export par email"
                  className={styles.floatingMedium}
                />
              </ScrollParallax>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInRight" 
                offset={500}
                style={{
                  position: 'absolute',
                  bottom: '-10%',
                  right: '5%',
                  zIndex: 4
                }}
              >
                <img
                  src="/images/content/export-pdf.svg"
                  alt="Export PDF"
                  className={styles.floatingLarge}
                />
              </ScrollParallax>
            </div>
          </div>

          {/* Côté droit - Texte et FAQ */}
          <div className={styles.rightContent}>
            <h2 className={cn("h2", styles.title)}>
            Mémos et relances prospects
            </h2>
            <div className={styles.info}>
              Optimisez votre suivi commercial avec des mémos détaillés et un système de relances automatisées pour convertir vos prospects.
            </div>
            
            <div className={styles.faqList}>
              {faqItems.map((item) => (
                <ScrollParallax key={item.id} className={styles.faqItem}>
                  <div
                    className={cn(styles.faqHead, { [styles.active]: activeItem === item.id })}
                    onClick={() => toggleItem(item.id)}
                  >
                    <div className={styles.faqTitle}>
                      <span className={styles.questionNumber}>
                        {item.id.toString().padStart(2, '0')}.
                      </span>
                      {item.title}
                    </div>
                    <div className={styles.faqArrow}>
                      <Icon name="arrow-bottom" size="10" />
                    </div>
                  </div>
                  <div className={cn(styles.faqBody, { [styles.visible]: activeItem === item.id })}>
                    <div className={styles.faqContent}>
                      <p>{item.content}</p>
                      {item.details && (
                        <ul className={styles.detailsList}>
                          {item.details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.checkIcon}>
                                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>


        </div>
      </div>
    </div>
  );
};

export default ExportEmargement;
